import { CardAvailable } from './card-avaliable'
import { CardDelayed } from './card-delayed'
import { CardDelayedBlocked } from './card-delayed-blocked'
import { CardLocked } from './card-locked'
import { CardPaid } from './card-paid'

export const InvoiceCoursing = {
  CardDelayed,
  CardLocked,
  CardPaid,
  CardAvailable,
  CardDelayedBlocked
}
